module.exports = __webpack_public_path__ + "img/storyboard-menu-creation.457fa43f.gif";